import { ChevronRight } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { UserRole } from "~/__generated__/graphql"
import { adminCreateAdminPath } from "~/common/paths"
import { Button } from "~/ui/button"
import { UsersTable } from "./users-table"

export function AdminAdminUsersScreen() {
  const navigate = useNavigate()

  const handleCreateAdmin = () => {
    navigate(adminCreateAdminPath({}))
  }

  return (
    <UsersTable
      title="Admin Users"
      description="Find or search admin users within this page."
      userRole={UserRole.SystemAdmin}
      placeholder="Search Admin Users"
      actionButton={
        <Button onClick={handleCreateAdmin} className="flex items-center gap-2">
          Create Admin
          <ChevronRight className="h-4 w-4" />
        </Button>
      }
    />
  )
}
